import { useNavigate } from 'react-router-dom';
import { useWorkspace } from '../contexts/WorkspaceContext';

export function WorkspaceSwitcher() {
  const { workspaces, activeWorkspace, switchWorkspace } = useWorkspace();
  const navigate = useNavigate();

  if (workspaces.length <= 1) return null;

  return (
    <div className="space-y-0.5 max-h-48 overflow-y-auto">
      {workspaces.map((ws) => {
        const active = ws.id === activeWorkspace?.id;
        const displayName = ws.label ?? ws.name;
        const subLabel = ws.label ? ws.name : null;
        return (
          <button
            key={ws.id}
            onClick={() => switchWorkspace(ws.id)}
            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
              active
                ? 'bg-white/15 text-white font-medium'
                : 'text-[#a8bcc8] hover:bg-white/[0.06] hover:text-white'
            }`}
          >
            <span className="block truncate">{displayName}</span>
            {subLabel && (
              <span className="block text-[11px] text-white/40 truncate">{subLabel}</span>
            )}
          </button>
        );
      })}
      <button
        onClick={() => navigate('/onboarding')}
        className="w-full text-left px-3 py-2 rounded-lg text-sm text-[#a8bcc8] hover:bg-white/[0.06] hover:text-white transition-colors flex items-center gap-2 mt-1"
      >
        <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        Add Circle
      </button>
    </div>
  );
}
